module.exports = __webpack_public_path__ + "img/tile-min1.201447eb.jpg";